// Entry point for the build script in your package.json
import "@hotwired/hotwire-native-bridge"
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

import "trix"
import "@rails/actiontext"

// Custom Turbo Stream action for toast notifications
// Usage: <turbo-stream action="notify" message="..." icon="..." url="..."></turbo-stream>
Turbo.StreamActions.notify = function() {
  const message = this.getAttribute("message")
  const icon = this.getAttribute("icon") || "bell"
  const url = this.getAttribute("url")

  if (message) {
    window.dispatchEvent(new CustomEvent("notification:received", {
      detail: { message, icon, url }
    }))
  }
}
